"use client";

import { FC } from "react";

import {
  LoadingSpinner,
} from "apps/website/components/form/LoadingSpinner/LoadingSpinner";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

interface SignupLoadingScreenProps {
  uxT: (key: string) => string;
}

export const SignupLoadingScreen: FC<SignupLoadingScreenProps> = ({ uxT }) => (
  <div className="fixed inset-0 flex flex-col justify-center items-center gap-4">
    <LoadingSpinner color="black" size={32} />
    <TextSubtitle size={4}>{ uxT("loading") }</TextSubtitle>
  </div>
);
